import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PasswordPolicyDto } from 'src/app/share/interface/password.interface'
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PasswordPolicyService {
    private readonly apiUrl = `${environment.url}/api`; 

    constructor(private http: HttpClient) { }

    // Gets the set of current active policies
    getActivePolicy(): Observable<PasswordPolicyDto> {
        return this.http.get<any>(`${this.apiUrl}/PasswordPolicy/GetActivePolicy`).pipe(
            map(response => ({
                ...response,
                id: response.id.toString(),
                createdBy: response.createdBy?.toString() || null,
                modifyBy: response.modifyBy?.toString() || null,
                createdDate: response.createdDate ? new Date(response.createdDate).toISOString() : null,
                modifyDate: response.modifyDate ? new Date(response.modifyDate).toISOString() : null
            }))
        );
    }

    // Tells the backend to deactivate the current active policies
    // then create a new row in PasswordPolicies DB with the new policies 
    updatePolicy(policy: PasswordPolicyDto): Observable<any> {
        return this.http.post(`${this.apiUrl}/PasswordPolicy/UpdatePolicy`, policy);
    }
}
